const django_api = 'https://be.flappyblizz.com:8080/'
const django_api_autho = 'https://be.flappyblizz.com:8080/autho/'
const django_api_game = 'https://be.flappyblizz.com:8080/game/'
const reactjs_api = 'https://be.flappyblizz.com:8080/'
const django_ws_play = 'wss://be.flappyblizz.com:8080/play/'


const timer_delay = 100


export {
    django_api,
    django_api_autho,
    django_api_game,
    reactjs_api,
    timer_delay,
    django_ws_play
}